
import { ReactFlow, Background, Controls, MiniMap, Node, Edge, OnNodesChange, OnEdgesChange, OnConnect } from '@xyflow/react';
import { nodeTypes } from '../nodes/NodeTypes';
import { EditorControls } from '../../game-planner/editor/EditorControls';
import { useTouchGestures } from '@/hooks/useTouchGestures';

import '@xyflow/react/dist/style.css';
import '../editor-flow.css';

export interface FlowEditorProps {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: OnNodesChange;
  onEdgesChange: OnEdgesChange;
  onConnect: OnConnect;
}

export function FlowEditor({ 
  nodes, 
  edges, 
  onNodesChange, 
  onEdgesChange,
  onConnect 
}: FlowEditorProps) {
  const { touchEnabled } = useTouchGestures();

  return (
    <div className="border rounded-lg h-[calc(100dvh-230px)] relative">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        proOptions={{ hideAttribution: true }}
        fitView
        zoomOnPinch={touchEnabled}
        panOnDrag={touchEnabled ? [0, 1, 2] : true}
        className="touch-manipulation"
      >
        <Background />
        <Controls showInteractive={!touchEnabled} />
        <MiniMap />
      </ReactFlow>
      
      <EditorControls />
    </div>
  );
}
